<template>
    <div>
        <data-loader
            message="Calculating and compiling your valuation certificate. This may take several seconds. Do not refresh page until this has been completed."
            v-if="submitting"
        ></data-loader>
        <button
            class="btn primary btn-create"
            type="submit"
            @click="submitting = true"
        >
            Submit<i class="ml-2 far fa-plus-square"></i>
        </button>
    </div>
</template>

<script>
export default {
    props: {},
    data: function () {
        return {
            submitting: false,
        };
    },
    mounted() {},
    methods: {},
    computed: {},
};
</script>

<style lang="scss" scoped></style>
